// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"220310d1","211":"d8db3a8f","239":"ce7003e7","241":"8885c686","310":"1c4ae552","320":"ec38da5e","349":"fa0d3ec6","352":"8899013c","518":"2f93d538","641":"7f796fad","681":"1d188fa7","807":"94a911e1","834":"40048036","900":"9679a6d2","912":"9c6a7778","971":"3e49930f"}[chunkId] + ".chunk.js";
};